import { computed } from 'vue';
import { useStore } from 'vuex';
import yup from '@component_path/inquiry_form_common_module/customValidation';

export const useCityIdField = (required, messages = {}) => {
  const fieldName = computed(() => 'city_id');
  const validator = yup
    .number()
    .integer()
    .requirement(required, messages['requirement'] || '市区町村は必須項目です');

  return { validator, fieldName };
};

export const useCityIdStore = () => {
  const store = useStore();

  const cityId = computed(() => store.state.formData.city_id);
  const cities = computed(() => store.state.masterData.cities);
  const city = computed(() =>
    cities.value.find(city => city.value === cityId.value)
  );
  const cityText = computed(() => (city.value ? city.value.label : ''));
  const prefectureId = computed(() => store.state.formData.prefecture_id);
  const dispatcher = computed(() => 'formData/setCityId');

  return { prefectureId, cityId, cities, city, cityText, dispatcher };
};
